import { useEffect, useRef } from "react"
import { baseUrl } from "../apis"

// One shared EventSource for the whole app (SSE connections are a scarce
// per-browser resource). Server side: backend/utils/realtime.js.
let sharedSource = null
const getSource = () => {
    if (!sharedSource) {
        sharedSource = new EventSource(`${baseUrl}/api/realtime/events`)
    }
    return sharedSource
}

// Subscribes `handler` to a named realtime event (e.g. "catalog:changed").
// The event payload is only ever a hint of WHAT changed — handler should
// refetch its own data from the REST API rather than trust it, so a
// missed/duplicate event is harmless and the DB stays the source of truth.
export function useRealtimeEvent(eventName, handler) {
    const handlerRef = useRef(handler)
    handlerRef.current = handler

    useEffect(() => {
        const source = getSource()
        const listener = (event) => {
            let data = {}
            try {
                data = JSON.parse(event.data)
            } catch {
                // ignore malformed payloads — the handler doesn't need it anyway
            }
            handlerRef.current?.(data)
        }
        source.addEventListener(eventName, listener)
        return () => source.removeEventListener(eventName, listener)
    }, [eventName])
}
